import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTiktokShopProductsQuery = createQueryHook(
  CreatorIntegrationsApiClient.getTiktokPartnerProducts,
  {
    queryKey: ['tiktokShopProducts'],
  },
)
